<template>
  <div class="navbar-default home-header">
    <div class="container">
      <div class="navbar">
        <div class="navbar-header">
          <router-link class="navbar-brand" to="/">
            <img src="~@/assets/imgs/logo.png" style="height: 48px" alt="" />
          </router-link>
        </div>

        <div class="navbar-first hidden-sm-and-down" v-for="item in navigationBar" :key="item.title">
          <li class="nav-item1" @click="changeName(item)">
            <a>{{item.title}}</a>
          </li>
        </div>
        <div class="hidden-md-and-up">
          <el-dropdown @command="changeDropdown">
            <span class="el-dropdown-link" style="color:#fff">
              首页<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu trigger="click" slot="dropdown">
              <span v-for="item in navigationBar" :key="item.title">
                <el-dropdown-item :command="item.router">{{item.title}}</el-dropdown-item>
              </span>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="collapse navbar-collapse">
          <el-menu router class="el-menu-class" mode="horizontal">
            <el-submenu index="#">
              <template slot="title">课程中心</template>
              <el-menu-item index="/course/base">基础课程</el-menu-item>
              <el-menu-item index="/course">实训课程</el-menu-item>
            </el-submenu>
          </el-menu>
          <ul class="nav navbar-nav text-center">
            <div class="hidden-xs-only">
              <el-input placeholder="搜索感兴趣的课堂" v-model="search" size="mini">
                <el-button slot="append" icon="el-icon-search" @click="handSearch"></el-button>
              </el-input>
            </div>
            <template v-if="userInfo && userInfo.id">
              <!-- <li class="nav-item" @click="changePath({ name: 'userLesson' })">
                                <a>我的课堂</a>
                            </li> -->
              <!-- <div>
                <el-input placeholder="搜索感兴趣的课堂" v-model="search" size="mini">
                    <el-button slot="append" icon="el-icon-search" @click="handSearch"></el-button>
                </el-input>
              </div> -->
              <li class="message-status" @click="changePath('/users/message')">
                <!--                 <div>2</div> -->
                <!--                <a class="icon icon-message-hint"></a>-->
              </li>
              <li>
                <el-popover trigger="hover" width="280">
                  <div class="user-box">
                    <el-row class="user">
                      <el-col :span="5">
                        <el-avatar :src="userInfo.avatar | filterUrl">
                          <img src="~@/assets/imgs/user_icon.png" />
                        </el-avatar>
                      </el-col>
                      <el-col :span="19">
                        <h4 class="user-nickname" v-text="userInfo.nickname"></h4>
                        <p v-text="userInfo.roleNames.join(' ')"></p>
                        <p v-if="userInfo.inviteCode">
                          <strong>注册邀请码：</strong>
                          <span>{{userInfo.inviteCode}}</span>
                        </p>
                      </el-col>
                    </el-row>
                    <div class="links">
                      <el-button size="mini" plain round @click="changePath({name: 'personal'})">
                        我的主页
                      </el-button>
                      <el-button size="mini" plain round type="success" @click="changePath({ name: 'profile', query: { type: 'basicInformation' } })">
                        个人设置
                      </el-button>
                      <el-button v-if="isTeacher" size="mini" plain round @click="changePath({ name: 'profile', query: { type: 'inviteInfo' } })">
                        开课信息
                      </el-button>
                      <el-button v-if="isTeacher" size="mini" plain round @click="changePath({ name: 'profile', query: { type: 'scialAccount' } })">
                        社交账号
                      </el-button>
                    </div>
                    <div class="text-r footer">
                      <a @click="logout">退出登录</a>
                    </div>
                  </div>
                  <router-link :to="{ name: 'personal' }" slot="reference" class="avatar-link">
                    <el-avatar :size="44" :src="userInfo.avatar | filterUrl">
                      <img src="~@/assets/imgs/user_icon.png" />
                    </el-avatar>
                  </router-link>
                </el-popover>
              </li>
            </template>
            <ul class="nav navbar-nav header-sign" v-else>
              <li>
                <a @click="doLogin">登录</a>
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
    <commonLogin />
  </div>
</template>

<script>
import commonLogin from "@/components/common/login";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      search: "",
      user: {},
      dialogOpen: false,
      activeIndex: "1",
      navigationBar: [
        {
          title: "首页",
          router: {
            name: "lessons",
          },
        },
        // {
        //   title: '实训课程',
        //   router: {
        //     name: "lessonMajor",
        //   },
        // },
        // {
        //   title: '开课机构',
        //   router: {
        //     name: "lessonDept"
        //   },
        // },
        // {
        //   title: '一流课程',
        //   router: {
        //     name: "lessonMajor",
        //     query: {
        //       type: 2,
        //     }
        //   },
        // }
      ],
    };
  },
  components: {
    commonLogin,
  },
  computed: {
    ...mapGetters(["userInfo", "isTeacher", "loginVisible"]),
  },
  created() {
    this.search = this.$route.query["majorOrLabel"];
  },
  methods: {
    ...mapActions(["setLoginVisible", "LogOut", "setCurrentExpInfo"]),
    doLogin() {
      this.setLoginVisible(true);
    },
    logout() {
      this.LogOut();
    },
    /**
     * 点击”搜索“按钮
     */
    handSearch() {
      let search = this.search;
      let routerObj = {
        params: {},
        query: {},
      };
      if (["lessonMajor", "baseCourse"].includes(this.$route.name)) {
        routerObj.params = {
          ...routerObj.params,
          ...this.$route.params,
        };
        routerObj.query = {
          ...routerObj.query,
          ...this.$route.query,
        };
      }
      if (search) {
        routerObj.query.majorOrLabel = search;
      } else {
        delete routerObj.query.majorOrLabel;
      }
      this.$router.push(routerObj);
    },
    changePath(path) {
      this.$router.push(path);
    },
    changeName(item) {
      this.$router.push(item.router);
    },
    changeDropdown(route) {
      this.$router.push(route);
    },
    changePathTop() {
      this.$router.push({
        name: "lessonMajor",
        query: {
          type: "2",
        },
      });
    },
    changePathAll() {
      this.$router.push({ name: "lessonMajor" });
    },
  },
};
</script>

<style lang="less">
.home-header {
  .el-menu {
    &--horizontal {
      > .el-menu-item {
        border-bottom: none;
        &.is-active {
          border-bottom: none;
        }
      }
      > .el-submenu {
        &.is-active {
          .el-submenu {
            &__title {
              border-bottom: none;
            }
          }
        }
      }
    }
    &.el-menu {
      &--horizontal {
        border-bottom: none;
      }
    }
  }
  .el-menu-item,
  .el-submenu__title {
    font-size: 18px;
  }
  .collapse {
    .el-submenu {
      .el-submenu__title {
        color: #fff !important;
      }
    }
  }
}

.navbar-header {
  img {
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>

<style lang="less">
@import "~@/assets/css/common-header.less";
</style>
